import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../design-system/theme';
import { Icon } from '../../design-system/components/Icon';

const TopBarContainer = styled.header`
  height: 64px;
  background: ${theme.colors.bg};
  border-bottom: 1px solid ${theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 ${theme.spacing.xl};
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  box-sizing: border-box;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  margin-left: auto;
`;

const AccountButton = styled.button`
  background: none;
  border: none;
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.base};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  transition: ${theme.transitions.fast};
  
  &:hover {
    background: ${theme.colors.bgSecondary};
  }
`;

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${theme.borderRadius.full};
  background: ${theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.textInverse};
  font-weight: ${theme.typography.fontWeight.semibold};
`;

const Dropdown = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: ${theme.spacing.xs};
  background: ${theme.colors.bg};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.base};
  box-shadow: ${theme.shadows.lg};
  min-width: 200px;
  display: ${props => props.$isOpen ? 'block' : 'none'};
  z-index: 100;
`;

const DropdownItem = styled.button`
  width: 100%;
  padding: ${theme.spacing.md};
  background: none;
  border: none;
  text-align: left;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.base};
  color: ${theme.colors.textPrimary};
  cursor: pointer;
  transition: ${theme.transitions.fast};
  
  &:hover {
    background: ${theme.colors.bgSecondary};
  }
  
  &:first-child {
    border-radius: ${theme.borderRadius.base} ${theme.borderRadius.base} 0 0;
  }
  
  &:last-child {
    border-radius: 0 0 ${theme.borderRadius.base} ${theme.borderRadius.base};
  }
`;

const AccountSection = styled.div`
  position: relative;
`;

export const TopBar: React.FC = () => {
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    window.location.href = '/admin/login';
  };

  return (
    <TopBarContainer>
      <RightSection>
        <AccountSection>
          <AccountButton onClick={() => setAccountMenuOpen(!accountMenuOpen)}>
            <Avatar>A</Avatar>
            <Icon name="chevronDown" size={16} />
          </AccountButton>
          <Dropdown $isOpen={accountMenuOpen}>
            <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
          </Dropdown>
        </AccountSection>
      </RightSection>
    </TopBarContainer>
  );
};

export default TopBar;

